import React from "react"

interface TransferApplicationsSearchProps {
  transferApplicationId: number | undefined
  onTransferApplicationIdChange: (value: number | undefined) => void
  onSearch: (value: number | undefined) => void
}

const TransferApplicationsSearch: React.FC<TransferApplicationsSearchProps> = ({
  transferApplicationId,
  onTransferApplicationIdChange,
  onSearch,
}) => {
  const handleSearch = () => {
    onSearch(transferApplicationId)
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center bg-white py-2">
        <input
          type="text"
          placeholder="立替送金申請IDで検索"
          value={transferApplicationId}
          onChange={(e) =>
            onTransferApplicationIdChange(e.target.value ? Number(e.target.value) : undefined)
          }
          className="placeholder-opacity-4 rounded-md border border-solid border-gray-300 p-4 text-lg text-black placeholder-gray-400"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSearch()
            }
          }}
        />
      </div>
      <button
        onClick={handleSearch}
        className="border border-solid border-medium-gray bg-white px-3 py-4 text-sm text-black hover:bg-gray-50 rounded-md"
      >
        立替送金申請IDで検索
      </button>
    </div>
  )
}

export default TransferApplicationsSearch
